/* @flow */
/* eslint-env es6,browser */

import { extend, param } from './coreutils';

/**
 * @description module for logger functions
 * @module logger
 * @requires module:utils
 */

let utilLoggerGif = '';
const debugConsole = location.href.includes('__jsapi_debugconsole=1');

/**
 * Utility to check whether debugging is enabled/not.
 * Need to add '__jsapi_debugconsole=1' to the web page
 * URL query params
 *
 * @returns {boolean} - Debugging is enabled or not
 */
export function isdebugEnabled(): boolean {
  return debugConsole;
}

/**
 * setter for logger gif
 *
 * @param {string} loggerGif - Img URL
 * @returns {undefined}
 */
export function setLoggerGif(loggerGif: string) {
  utilLoggerGif = loggerGif;
}

/**
 * Utility function for sending logger gif request (From global.js in EOW)
 *
 * @param {string} cmd - Log message to send
 * @param {object} o - usr & count are not allowed/overwritten here
 * @returns {undefined}
 */
export function sendLoggerImg(cmd: string, o: {}) {
  cmd = cmd || '';
  o = o || {};
  if (!cmd.length || !utilLoggerGif.length) {
    return;
  }

  //deep copy & merging args
  extend(true, o, o, {
    command: cmd,
    count: new Date().getTime()
  });

  //convert into query param
  const beaconUrl = `${utilLoggerGif}?${param(o)}`;
  /*if (sendBeacon(beaconUrl)) {
    return;
  }*/

  // sendBeacon is not supported, send image tracking request
  const img = document.createElement('img');
  img.src = beaconUrl;
}

/**
 * Logging utility function
 *
 * @access private
 * @param {string} s  - string to be logged
 * @param {boolean} appLogging - Should log to back-end
 * @returns {undefined}
 */
function _log(s: string, appLogging: boolean) {
  s = s || '';
  /*eslint-disable no-console*/
  if (typeof console !== 'undefined' && debugConsole === true) {
    const c = console;
    c.log(s);
  }
  /*eslint-enable no-console*/
  if (appLogging === true) {
    sendLoggerImg('ADLOG', { msg: s });
  }
}

/**
 * function to log debug log
 *
 * @param {string} s - string to be logged
 * @returns {undefined}
 */
export function logDebug(s: string) {
  s = `AS:D:${s}`;
  _log(s, false);
}

/**
 * function to log error log
 *
 * @param {string} s - string to be logged
 * @returns {undefined}
 */
export function logError(s: string) {
  s = `AS:E:${s}`;
  _log(s, true);
}

/**
 * function to log info log
 *
 * @param {string} s - string to be logged
 * @returns {undefined}
 */
export function logInfo(s: string) {
  s = `AS:I:${s}`;
  _log(s, true);
}
